import React from 'react'

const Loader = () => {
  return (
    <div>
      <div className="center">
        <div className="spinner" />
      </div>
    </div>
  );
}

export default Loader